var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup"},[_vm._v(" "+_vm._s(_vm.data.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }